import React from 'react';
import Link from 'next/link';

import { UserLean } from 'legacy/user/types';
import { useRouter } from 'next/router';
import { isBounceWebview } from 'legacy/common/utils/webview';

type Props = {
  users: UserLean[];
  onDelete?: (user: UserLean) => void;
  isEditable?: boolean;
};

const UsersList = ({ users, onDelete, isEditable }: Props) => {
  const router = useRouter();
  const isWebview = isBounceWebview(router.query);

  const onDeleteHandler = (user) => () => {
    onDelete(user);
  };

  return (
    <ul className="flex flex-col gap-4">
      {users.map((user) => (
        <li className="flex align-center" key={user._id}>
          <Link
            href={!isWebview ? `/profile/${user._id}` : ''}
            data-testid="organizer-link"
            className="flex flex-1 align-center"
          >
            <div className="flex items-center w-10 h-10 rounded-full justify-center overflow-hidden border-2 border-primary-400">
              <img
                src={user?.photo?.url || '/img/search/user.svg'}
                alt={`${user.firstName}'s Profile Pic`}
              />
            </div>
            <div className="flex-1 pl-4">{`${user.firstName} ${user.lastName}`}</div>
          </Link>
          {isEditable && (
            <button
              className="p-4"
              onClick={onDeleteHandler(user)}
              type="button"
            >
              <img src="/img/icons/delete.svg" alt="Delete" />
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};

export default UsersList;
